  // Layout/Sidebar.jsx
  import React, { useState } from "react";
  import {
    Home,
    BarChart3,
    Users,
    DollarSign,
    Calendar,
    Settings,
    LogOut,
    User,
  } from "lucide-react";

  export default function Sidebar({ userData, sidebarOpen }) {
    const [activeTab, setActiveTab] = useState("dashboard");

    return (
      <div
        id="sidebar"
        className={`fixed inset-y-0 left-0 z-20 transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 transition-transform duration-300 bg-gray-900 w-64 pt-16 shadow-xl`}
      >
        <div className="px-4 py-3 border-b border-gray-800">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-full bg-blue-500 flex items-center justify-center overflow-hidden">
              {userData.avatar ? (
                <img
                  src={userData.avatar}
                  alt="Avatar"
                  className="h-full w-full object-cover"
                />
              ) : (
                <User size={20} />
              )}
            </div>
            <div className="overflow-hidden">
              <h3 className="font-medium truncate">{userData.name}</h3>
              <p className="text-xs text-gray-400 truncate">{userData.typeU}</p>
            </div>
          </div>
        </div>

        <nav className="mt-4 px-2">
          <button
            onClick={() => setActiveTab("dashboard")}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${
              activeTab === "dashboard" ? "bg-blue-600" : "hover:bg-gray-800"
            }`}
          >
            <Home
              size={18}
              className={
                activeTab === "dashboard" ? "text-white" : "text-gray-400"
              }
            />
            <span>Dashboard</span>
          </button>

          <button
            onClick={() => setActiveTab("analytics")}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${
              activeTab === "analytics" ? "bg-blue-600" : "hover:bg-gray-800"
            }`}
          >
            <BarChart3
              size={18}
              className={
                activeTab === "analytics" ? "text-white" : "text-gray-400"
              }
            />
            <span>Analíticas</span>
          </button>

          <button
            onClick={() => setActiveTab("users")}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${
              activeTab === "users" ? "bg-blue-600" : "hover:bg-gray-800"
            }`}
          >
            <Users
              size={18}
              className={activeTab === "users" ? "text-white" : "text-gray-400"}
            />
            <span>Usuarios</span>
          </button>

          <button
            onClick={() => setActiveTab("earnings")}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${
              activeTab === "earnings" ? "bg-blue-600" : "hover:bg-gray-800"
            }`}
          >
            <DollarSign
              size={18}
              className={
                activeTab === "earnings" ? "text-white" : "text-gray-400"
              }
            />
            <span>Ganancias</span>
          </button>

          <button
            onClick={() => setActiveTab("calendar")}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${
              activeTab === "calendar" ? "bg-blue-600" : "hover:bg-gray-800"
            }`}
          >
            <Calendar
              size={18}
              className={
                activeTab === "calendar" ? "text-white" : "text-gray-400"
              }
            />
            <span>Calendario</span>
          </button>

          <button
            onClick={() => setActiveTab("settings")}
            className={`flex items-center gap-3 w-full px-4 py-3 rounded-lg ${
              activeTab === "settings" ? "bg-blue-600" : "hover:bg-gray-800"
            }`}
          >
            <Settings
              size={18}
              className={
                activeTab === "settings" ? "text-white" : "text-gray-400"
              }
            />
            <span>Configuración</span>
          </button>
        </nav>

        <div className="absolute bottom-4 left-0 right-0 px-4">
          <button className="flex items-center gap-3 w-full px-4 py-3 rounded-lg text-red-400 hover:bg-gray-800">
            <LogOut size={18} />
            <span>Cerrar sesión</span>
          </button>
        </div>
      </div>
    );
  }
